import { render, staticRenderFns } from "./yScroll.vue?vue&type=template&id=0bba0c44&"
import script from "./yScroll.vue?vue&type=script&lang=js&"
export * from "./yScroll.vue?vue&type=script&lang=js&"
import style0 from "./yScroll.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports